import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

export default function LastWords() {
    const { t } = useTranslation();
    const [open, setOpen] = useState(true);

    return (
        <>
            <Modal show={open} onClose={() => setOpen(false)} width={600}>
                <div className="flex flex-col items-center gap-6 p-6">
                    <h2 className="text-center text-xl md:text-2xl font-bold text-gray-800">
                        {t('lastWords.title')}
                    </h2>
                    <p className="text-justify text-sm md:text-base leading-relaxed text-gray-600">
                        {t('lastWords.paragraph1')}
                        <br />
                        {t('lastWords.paragraph2')}
                        <br />
                        <br />
                        {t('lastWords.paragraph3')}
                        <br />
                        {t('lastWords.paragraph4')}
                        <br />
                        <br />
                        {t('lastWords.paragraph5')}
                        <br />
                        {t('lastWords.paragraph6')}
                        <br />
                        <br />
                        {t('lastWords.paragraph7')}
                    </p>
                    <div className="flex flex-wrap justify-center gap-4 text-sm md:text-base">
                        {[
                            { name: 'Patryk Rusak', link: 'https://www.linkedin.com/in/patryk-rusak/' },
                            { name: 'Maksymilian Zbroja', link: 'https://www.linkedin.com/in/maksymilian-zbroja/' },
                            { name: 'Wiktor Nedew', link: 'https://www.linkedin.com/in/wiktor-nedew-0a7657247/' },
                            { name: 'Adam Kalinowski', link: 'https://www.linkedin.com/in/kalinowskyyy/' },
                            { name: 'Michał Łukasiak', link: 'https://www.linkedin.com/in/micha%C5%82-%C5%82ukasiak-631507243/' },
                            { name: 'Weronika Woroszczuk', link: 'https://www.linkedin.com/in/weronika-woroszczuk/' },
                            { name: 'Mateusz Łojewski', link: 'https://www.facebook.com/mateusz.lojewski.7' }
                        ].map((person, index) => (
                            <a
                                key={index}
                                href={person.link}
                                className="text-SM-yellow hover:underline"
                                target="_blank"
                                rel="noopener noreferrer">
                                {person.name}
                            </a>
                        ))}
                    </div>
                    <button
                        onClick={() => setOpen(false)}
                        className="rounded bg-SM-yellow px-6 py-3 text-lg text-white transition-all hover:brightness-90">
                        {t('lastWords.close')}
                    </button>
                </div>
            </Modal>
        </>
    );
}